import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  border-radius: ${({ radius }) => radius}px;
  background-color: ${({ bgClr }) => bgClr};
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  border: 1px solid rgba(7, 80, 115, 0.1);
  position: relative;

  ${({ addMarginLeft }) =>
    addMarginLeft && `margin-left: 6px; width: calc(100% - 6px);`}
`;

export const IconTitleWrapper = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: ${({ align }) => align || "center"};
`;

export const Title = styled.div`
  color: ${({ clr }) => clr};
  font-size: 16px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.4px;
  flex: 1;
  position: relative;
  display: grid;
  align-items: center;
  white-space: pre-line;
  text-align: left;
`;

export const Text = styled.div`
  color: ${({ clr }) => clr};
  font-size: 16px;
  font-weight: 400;
  line-height: 170%;
  letter-spacing: 0.4px;
  flex: 1;
  position: relative;
  white-space: pre-line;
  outline: none;

  ${({ isTemplate }) =>
    isTemplate
      ? `
          display: -webkit-box;
          overflow: hidden;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
  `
      : ""}
`;

export const IconContainer = styled.div`
  display: grid;
  place-content: center;
  width: 24px;
  height: 24px;

  ${({ color }) => {
    if (color) {
      return `
        svg {
          fill: ${color};
          path {
            fill: ${color};
          }
        }
      `;
    }
    return "";
  }}
`;

export const DotElement = styled.div`
  position: absolute;
  top: 25px;
  left: -6px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  box-sizing: border-box;
  background-color: ${({ bgClr }) => bgClr};
  border: 1px solid ${({ borderColor }) => borderColor};
`;

export const Emoji = styled.div`
  display: grid;
  place-content: center;
  font-size: 24px;
`;
